import { inject } from '@angular/core';
import { ResolveFn } from '@angular/router';
import { Observable } from 'rxjs';

import { IEmailLogs } from '../../../utils/interfaces/email-log';
import { IResponse } from '../../../utils/interfaces/response';
import { EmailService } from '../email.service';

export const getScheduledEmailLogs: ResolveFn<
  Observable<IResponse<IEmailLogs[]>>
> = (route, state) => {
  const emailService = inject(EmailService);
  return emailService.getScheduledEmailLogs(false, '', 1, 10, null);
};
